import { IAppEntity } from "src/config/entities";
import React from "react";
import { ReferenceTypes } from "src/enums/ReferenceTypes";
import { NFLookupPurchaseOrder } from "src/components/Shared/NewForms/NFLookupPurchaseOrder";
import { PurchaseOrdersService } from "src/services/documents/PurchaseOrdersService";
import { DocumentPostStatusEnum } from "src/enums/DocumentPostStatusEnum";
import { PurchaseOrderDetail } from "src/components/Pages/Documents/Purchases/PurchaseOrders/components/PurchaseOrderDetail";
import PurchaseOrdersList from "src/components/Pages/Documents/Purchases/PurchaseOrders/components/PurchaseOrdersList";
import { ICreatePurchaseOrdersDto } from "src/components/Pages/Documents/Purchases/PurchaseOrders/dtos/ICreatePurchaseOrdersDto";
import { OpenBalanceOfGoodsDetail } from "src/components/Pages/Documents/Warehouse/OpenBalanceOfGoods/components/OpenBalanceOfGoodsDetail";
import OpenBalanceOfGoodsList from "src/components/Pages/Documents/Warehouse/OpenBalanceOfGoods/components/OpenBalanceOfGoodsList";
import { NFLookupOpenBalanceOfGoods } from "src/components/Shared/NewForms/NFLookupOpenBalanceOfGoods";

export const OpenBalanceOfGoods: IAppEntity = {
  entityType: "document",
  title: "Open Balance Of Goods",
  pluralTitle: "Open Balance Of Goods",
  apiUrl: "OpenBalanceOfGoods",
  apiEnum: ReferenceTypes.DocumentOpenBalanceOfGood,
  getDetailView: (id?: string) => {
    return React.createElement(OpenBalanceOfGoodsDetail, {
      id: id
    });
  },
  getDetailViewComponent: (model: any, modelUpdatedEvent: (model: any) => void) => React.createElement(React.Fragment, {}),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(OpenBalanceOfGoodsList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent
    }),

  getLookupComponent(model: any): any {
    return React.createElement(NFLookupOpenBalanceOfGoods, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog
    });
  },
  getDataService: () => new PurchaseOrdersService("OpenBalanceOfGoods"),
  getEmptyModel: () => {
    const model: ICreatePurchaseOrdersDto = {
      totalAmount: 0,
      totalAmountVat: 0,
      status: DocumentPostStatusEnum.Draft,
      documentDate: new Date(),
      createdDate: new Date()
      // products: [],
      // services: [],
      // paymentOffsets: [],
    };
    return model;
  }
};

